const setShowModal = (payload) => {
  return {
    type: "setShowModal",
    payload,
  };
};

export default setShowModal;
